import * as React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { connect } from "react-redux"
import { bindActionCreators, Dispatch } from "redux"
import { defaults } from 'chart.js'
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
import * as numbro from "handsontable/node_modules/numbro"
import frFR from "handsontable/node_modules/numbro/languages/fr-FR.js"
import * as actionCreators from "./action-creators"
import ToastNotification from "./component/notification/toast-notification"
import { ReducerState, MappedActionsProps } from "./reducer"
import * as routes from "./util/routes"
import Auth from "./service/auth"
import Login from "./route/login"
import ResetPassword from "./route/reset-password"
import Secured from "./route/secured"
import ReactGA from "react-ga4";
import "@fortawesome/fontawesome-free/js/all"
import './component/style/common.scss'

defaults.global.elements.line.tension = 0
defaults.global.legend.labels.boxWidth = 12
defaults.global.legend.position = "bottom"

numbro.culture(frFR.cultureCode, frFR)

library.add(fas)

class App extends React.Component<InjectedProps> {
    componentDidMount() {
        if (process.env.REACT_APP_SFP_GOOGLE_TRACK_ID) {
            ReactGA.initialize(process.env.REACT_APP_SFP_GOOGLE_TRACK_ID, {
                testMode: process.env.NODE_ENV !== "production",
                gaOptions: {
                    siteSpeedSampleRate: 100,
                },
            });
        }
    }
    render() {
        const rootStyle: React.CSSProperties = {
            height: "100%",
            left: 0,
            position: "absolute",
            width: "100%",
            top: 0
        }
        const buttonContainerStyle: React.CSSProperties = {
            height: "45px",
            marginTop: "1px",
            marginRight: "2px",
            width: "100%",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
        }
        const buttonStyle: React.CSSProperties = {
            padding: '2px 18px 2px 18px'
        }
        const notifications = this.props.notifications

        return (
            <div style={rootStyle}>
                {(notifications && 0 !== notifications.length)
                    ? (
                        <ToastNotification
                            error={notifications[0].error}
                            level={notifications[0].level}
                            message={notifications[0].message}
                            symbol={notifications[0].symbol}
                            onClose={(symbol) => this.handleCloseNotification(symbol)}
                        />
                    )
                    : null
                }
                <Router>
                    <Switch>
                        <Route
                            exact
                            path={routes.RESET_PASSWORD_PATTERN}
                            component={ResetPassword}
                        />
                        <Route
                            path={routes.ROOT}
                            render={(props) =>
                                Auth.isLogged() ? <Secured {...props} /> : <Login {...props} />
                            }
                        />
                    </Switch>
                </Router>
            </div>
        )
    }

    private handleCloseNotification(symbol: Symbol): void {
        this.props.actions.unnotify(symbol)
    }
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state
}

export default connect(mapStateToProps, mapDispatchToProps)(App)

export interface Props { }

type InjectedProps = MappedActionsProps & Props & ReducerState



// WEBPACK FOOTER //
// ./src/App.tsx